import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import { api } from '@/store/api'
import config from '@/config/environment'
// ❌ REMOVIDO: Não usar mais modelos JSON estáticos
// import filter from '../assets/filterModel'
// import filterCustomer from '../assets/filterCustomerModel'
import userActions from './actions/user'
import _ from 'lodash'

// ALTERADO: Importa o novo módulo da API
import apiModule from './modules/api'

Vue.use(Vuex)

console.log('🔄 Vuex Store Migration: Usando API REST PostgreSQL')

export default new Vuex.Store({
  modules: {
    api: apiModule // Adiciona o módulo da API ao store
  },
  state: {
    user: null,
    userData: null,
    loading: false,
    passwordWarning: null, // 🔐 Aviso de senha próxima à expiração
    filterModel: null,
    filtersState: [],
    filterLogic: 'AND', // Lógica de combinação dos filtros
    count: 0,
    scheduleCount: 0,
    companyData: null,
    selectedConvenio: null, // Convênio selecionado para filtros
    // 🏢 ESTADO PARA FILTROS POR CONVÊNIO
    convenioFilters: {
      convenio: '',
      fields: [],
      operators: {},
      lastUpdated: null
    },
    boardItems: [
      { text: 'Arquivo', value: 'arquivo' },
      { text: 'Prospecção', value: 'leads' },
      { text: 'Apresentação', value: 'apresentacao' },
      { text: 'Negociação', value: 'negociacao' },
      { text: 'Fechamento', value: 'fechamento' }
    ],
    boardCustomers: {
      arquivo: [],
      leads: [],
      apresentacao: [],
      negociacao: [],
      fechamento: []
    },
    statuses: [],
    campaigns: [],
    attendents: [],
    users: [],
    customersInfos: [],
    contractStatuses: []
  },

  getters: {
    isAdmin: (state) => {
      if (state.user && state.user.profile) {
        return state.user.profile === 'administrator'
      } else return false
    },
    profile: (state) => {
      if (state.user && state.user.profile) {
        return state.user.profile
      } else return ''
    },
    company: (state) => {
      if (state.user && state.user.companyId) {
        return state.user.companyId
      } else return ''
    },
    companyData: (state) => state.companyData,
    userData: (state) => state.userData,
    branch: (state) => {
      if (state.user && state.user.branchId) {
        return state.user.branchId
      } else return ''
    },
    loading: (state) => {
      return state.loading
    },
    user: (state) => {
      return state.user
    },
    customersInfo: (state) => {
      return state.customersInfo
    },
    count: (state) => {
      return state.count
    },
    filterState: (state) => {
      return state.filtersState
    },
    scheduleCount: (state) => state.scheduleCount,
    // 🏢 GETTERS PARA FILTROS POR CONVÊNIO
    convenioFilters: (state) => state.convenioFilters,
    selectedConvenio: (state) => state.convenioFilters.convenio,
    availableFields: (state) => {
      // 🔍 LOG DETALHADO - Estado dos campos disponíveis
      console.log('🔍 DEBUG - Getter availableFields chamado:', {
        convenioFiltersFields: state.convenioFilters.fields,
        fieldsLength: state.convenioFilters.fields ? state.convenioFilters.fields.length : 'undefined',
        convenioFiltersState: state.convenioFilters
      })
      return state.convenioFilters.fields
    },
    convenioOperators: (state) => state.convenioFilters.operators,
    availableOperators: (state) => state.convenioFilters.operators || {},
    hasConvenioSelected: (state) => !!state.convenioFilters.convenio,
    // 🔄 NOVO: Getter para verificar se convênio foi carregado
    isConvenioLoaded: (state) => {
      return state.convenioFilters.convenio && state.convenioFilters.fields.length > 0
    },
    // 🎯 GETTER PARA CAMPOS ORGANIZADOS POR CATEGORIA
    organizedFields: (state) => {
      const fields = state.convenioFilters.fields || []

      // Organizar campos por categoria baseado no tipo e nome
      const categories = {
        pessoais: {
          name: 'Dados Pessoais',
          icon: 'mdi-account',
          color: 'blue',
          availableFields: []
        },
        financeiros: {
          name: 'Dados Financeiros',
          icon: 'mdi-currency-usd',
          color: 'green',
          availableFields: []
        },
        funcionais: {
          name: 'Dados Funcionais',
          icon: 'mdi-briefcase',
          color: 'orange',
          availableFields: []
        },
        contratuais: {
          name: 'Dados Contratuais',
          icon: 'mdi-file-document',
          color: 'purple',
          availableFields: []
        },
        geograficos: {
          name: 'Localização',
          icon: 'mdi-map-marker',
          color: 'red',
          availableFields: []
        }
      }

      // Categorizar campos automaticamente
      fields.forEach(field => {
        const fieldName = field.name.toLowerCase()
        const fieldLabel = field.label ? field.label.toLowerCase() : fieldName

        if (fieldName.includes('idade') || fieldName.includes('nome') || fieldLabel.includes('idade')) {
          categories.pessoais.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        } else if (fieldName.includes('salario') || fieldName.includes('bruto') || fieldName.includes('liquido') ||
                   fieldName.includes('margem') || fieldName.includes('saldo') || fieldLabel.includes('salário') ||
                   fieldLabel.includes('margem') || fieldLabel.includes('saldo')) {
          categories.financeiros.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        } else if (fieldName.includes('cargo') || fieldName.includes('orgao') || fieldName.includes('situacao') ||
                   fieldName.includes('regime') || fieldName.includes('jornada') || fieldName.includes('pg') ||
                   fieldName.includes('cat') || fieldName.includes('ind')) {
          categories.funcionais.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        } else if (fieldName.includes('parcela') || fieldName.includes('banco') || fieldName.includes('cod') ||
                   fieldName.includes('contrato') || fieldName.includes('nb')) {
          categories.contratuais.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        } else if (fieldName.includes('cidade') || fieldName.includes('uf') || fieldName.includes('sigla')) {
          categories.geograficos.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        } else {
          // Campos que não se encaixam em nenhuma categoria vão para funcionais
          categories.funcionais.availableFields.push({
            text: field.label || field.name,
            value: field.name,
            type: field.type,
            table: field.table,
            operators: field.operators
          })
        }
      })

      // Filtrar categorias que têm campos
      return Object.values(categories).filter(category => category.availableFields.length > 0)
    }
  },

  actions: {
    // 🔐 USER ACTIONS
    ...userActions,
    async loadUsers({ commit, state }) {
      try {
        const company = state.user.companyId
        const branch = state.user.branchId

        const params = {
          orderBy: 'name',
          limit: 1000,
          ...(state.user.profile === 'attendant' && { userId: state.user.uid }),
          ...(state.user.profile === 'manager' && { companyId: company }),
          ...(state.user.profile === 'supervisor' && { branchId: branch })
        }

        const response = await api.get('/users', { params })
        // Correção: userController retorna { data: users, ... }
        const users = response.data.data || []

        commit('updateUsers', users)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 loadUsers migrated:', users.length, 'users loaded')
        }
      } catch (error) {
        console.error('loadUsers error:', error)
        commit('updateUsers', [])
      }
    },

    async loadCustomersInfos({ commit, state }) {
      try {
        const response = await api.get('/customers/infos', {
          params: {
            orderBy: 'blacklistInfo.date',
            direction: 'desc',
            limit: 50
          }
        })

        const customersInfos = response.data.data || []
        commit('updateCustomersInfos', customersInfos)

        if (config.MONITORING.DEBUG_MODE) {
          console.log(
            '🔄 loadCustomersInfos migrated:',
            customersInfos.length,
            'infos loaded'
          )
        }

        return customersInfos
      } catch (error) {
        console.error('loadCustomersInfos error:', error)
        commit('updateCustomersInfos', [])
        return []
      }
    },

    async loadCampaigns({ commit, state }) {
      try {
        const company = state.user.companyId
        const profile = state.user.profile
        const uid = state.user.uid

        let campaigns = []

        if (profile === 'attendant') {
          const response = await api.get('/distributions', {
            params: {
              companyId: company,
              userId: uid
            }
          })

          const distributions = response.data.data || []
          campaigns = distributions.map((item) => ({
            iuid: item.campaign.id,
            name: item.campaign.name
          }))
        } else {
          const params = {
            orderBy: 'name',
            ...(profile === 'manager' && { companyId: company }),
            ...(profile === 'supervisor' && { companyId: company })
          }

          const response = await api.get('/campaigns', { params })
          campaigns = response.data.data || []
        }

        const sortedCampaigns = campaigns.sort((a, b) =>
          a.name > b.name ? 1 : -1
        )
        commit('updateCampaigns', sortedCampaigns)

        if (config.MONITORING.DEBUG_MODE) {
          console.log(
            '🔄 loadCampaigns migrated:',
            sortedCampaigns.length,
            'campaigns loaded'
          )
        }
      } catch (error) {
        console.error('loadCampaigns error:', error)
        commit('updateCampaigns', [])
      }
    },

    async loadStatuses({ commit, state }) {
      try {
        const company = state.user.companyId

        const response = await api.get('/status', {
          params: { companyId: company }
        })

        let statuses = response.data.data || []

        statuses = [
          { iuid: 'NOVO', name: 'Novo' },
          { iuid: 'CAMPANHA', name: 'Campanha' }
        ].concat(statuses.sort((a, b) => (a.name > b.name ? 1 : -1)))

        commit('updateStatuses', statuses)

        if (config.MONITORING.DEBUG_MODE) {
          console.log(
            '🔄 loadStatuses migrated:',
            statuses.length,
            'statuses loaded'
          )
        }
      } catch (error) {
        console.error('loadStatuses error:', error)
        commit('updateStatuses', [])
      }
    },

    async loadBoardCustomers({ commit, state }, payload) {
      try {
        const company = state.user.companyId
        const branch = state.user.branchId
        const profile = state.user.profile

        const baseParams = {
          orderBy: 'order',
          ...(profile === 'attendant' && { attendantId: state.user.uid }),
          ...(profile === 'manager' && { companyId: company }),
          ...(profile === 'supervisor' && { branchId: branch })
        }

        if (payload && payload.filters) {
          const filters = payload.filters
          if (filters.search && filters.search.length > 0) {
            baseParams.search = filters.search
          }
          if (filters.statuses && filters.statuses.length) {
            baseParams.statusIds = filters.statuses.join(',')
          }
          if (filters.campaigns) {
            baseParams.campaignId = filters.campaigns
          }
          if (filters.users) {
            baseParams.attendantId = filters.users
          }
        }

        const boardKeys = payload
          ? payload.boards
          : Object.keys(state.boardCustomers)

        for (const boardKey of boardKeys) {
          try {
            const response = await api.get('/board/customers', {
              params: {
                ...baseParams,
                board: boardKey,
                limit: 200
              }
            })

            const customers = response.data.data || []
            commit('updateBoardCustomers', { board: boardKey, customers })

            if (config.MONITORING.DEBUG_MODE) {
              console.log(
                `🔄 loadBoardCustomers migrated [${boardKey}]:`,
                customers.length,
                'customers'
              )
            }
          } catch (error) {
            console.error(`loadBoardCustomers [${boardKey}] error:`, error)
            commit('updateBoardCustomers', { board: boardKey, customers: [] })
          }
        }
      } catch (error) {
        console.error('loadBoardCustomers error:', error)
      }
    },

    async updateCustomer({ commit, state }, payload) {
      try {
        const data = payload.data
        const customer = payload.customer

        const history = []
        if (data.board) history.push(`Movido para o painel ${data.board}.`)
        if (data.rating) {
          history.push(`Qualificado como ${data.rating} estrelas.`)
        }
        if (data.contractStatus) {
          history.push(
            `Alterado o status da contrato para ${data.contractStatus}.`
          )
        }
        if (data.contractValue) {
          history.push(
            `Alterado o valor da proposta para ${data.contractValue}.`
          )
        }
        if (data.contractValuePaid) {
          history.push(
            `Alterado o valor do contrato pago para ${data.contractValuePaid}.`
          )
        }

        const callData = {
          user: {
            id: state.userData.iuid,
            name: state.userData.name || null
          },
          customer: {
            id: customer.iuid,
            name: customer.nome || null,
            cpf: customer.cpf || null
          },
          company: customer.company || null,
          branch: customer.branch || null,
          campaign: customer.campaign || null,
          description: history.join('; '),
          contractValue: data.contractValue || 0,
          contractValuePaid: data.contractValuePaid || 0,
          contractStatus: data.contractStatus || null
        }

        const response = await api.put(`/customers/${customer.iuid}`, data)

        if (history.length > 0) {
          await api.post('/audits', {
            action: 'UPDATE_CUSTOMER',
            entity: 'customer',
            entityId: customer.iuid,
            data: callData,
            description: callData.description
          })
        }

        _.merge(customer, data)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 updateCustomer migrated:', customer.iuid, data)
        }

        return response.data
      } catch (error) {
        console.error('updateCustomer error:', error)
        throw error
      }
    },

    async loadCompanyData({ commit, state }) {
      try {
        if (!state.user.companyId) return null

        const response = await api.get(`/companies/${state.user.companyId}`)
        const companyData = (response && response.data && response.data.data)
          ? response.data.data
          : response.data

        commit('setCompanyData', companyData)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 loadCompanyData migrated:', companyData)
        }

        return companyData
      } catch (error) {
        console.error('loadCompanyData error:', error)
        return null
      }
    },

    async findUsersCount({ commit, state }) {
      try {
        if (!state.user.companyId) return 0

        const response = await api.get('/users/count', {
          params: {
            companyId: state.user.companyId,
            excludeDisabled: true
          }
        })

        const count = response.data.count || 0

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 findUsersCount migrated:', count)
        }

        return count
      } catch (error) {
        console.error('findUsersCount error:', error)
        return 0
      }
    },

    async agreeTerms({ commit, state }, payload) {
      try {
        const companyId = state.user.companyId
        const termsData = {
          ...payload,
          date: new Date(),
          userId: state.user.uid,
          userEmail: state.user.email,
          agreed: true
        }

        await api.put(`/companies/${companyId}/terms`, { terms: termsData })

        commit('agreeTerms', payload)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 agreeTerms migrated:', termsData)
        }
      } catch (error) {
        console.error('agreeTerms error:', error)
        throw error
      }
    },

    async agreeContract({ commit, state }, payload) {
      try {
        const companyId = state.user.companyId
        const contractData = {
          contract: {
            ...payload,
            date: new Date(),
            userId: state.user.uid,
            userEmail: state.user.email,
            agreed: true
          },
          terms: {
            userName: payload.userName,
            date: new Date(),
            userId: state.user.uid,
            userEmail: state.user.email,
            agreed: true
          }
        }

        await api.put(`/companies/${companyId}/contract`, contractData)

        commit('agreeContract', payload)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 agreeContract migrated:', contractData)
        }
      } catch (error) {
        console.error('agreeContract error:', error)
        throw error
      }
    },

    async disagreeContract({ commit, state }, payload) {
      try {
        const companyId = state.user.companyId
        const contractData = {
          plan: 'disagree',
          date: new Date(),
          userId: state.user.uid,
          agreed: false,
          feeValue: 0
        }

        await api.put(`/companies/${companyId}`, {
          disabled: true,
          contract: contractData
        })

        commit('disagreeContract', payload)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 disagreeContract migrated:', contractData)
        }
      } catch (error) {
        console.error('disagreeContract error:', error)
        throw error
      }
    },

    setLoading({ commit, state }, payload) {
      commit('setLoading', payload)

      // 🔄 Sincronizar com LoadingService
      if (
        typeof window !== 'undefined' &&
        window.Vue &&
        window.Vue.prototype.$loading
      ) {
        if (payload) {
          window.Vue.prototype.$loading.start('vuex-global')
        } else {
          window.Vue.prototype.$loading.stop('vuex-global')
        }
      }
    },

    async submitCampaign(
      { commit, state, getters, dispatch },
      { modelCampaign, filter, convenio, totalCustomers, intuitivesFilters }
    ) {
      // ALTERAÇÃO 1: Declarar as variáveis aqui no topo com 'let'
      let createResponse = null
      let saveResponse = null

      try {
        commit('setLoading', true)

        const user = getters.user

        // Função auxiliar para preparar settings
        const prepareSettings = (currentSettings) => {
          const s = currentSettings || {}
          const importLimit = parseInt(s.importLimit || s.import_limit, 10)
          const exportLimit = parseInt(s.exportLimit || s.export_limit, 10)
          
          // Preservar outras configurações
          const out = { ...s }
          
          if (Number.isFinite(importLimit) && importLimit > 0) out.importLimit = importLimit
          if (Number.isFinite(exportLimit) && exportLimit > 0) out.exportLimit = exportLimit
          
          // Injetar filtros intuitivos e convênio se fornecidos
          if (intuitivesFilters) {
            out.intuitiveFilters = intuitivesFilters
            console.log('✅ intuitiveFilters injetados no settings:', Object.keys(intuitivesFilters).length, 'chaves')
          }
          if (convenio) {
            out.selectedConvenio = convenio
          }
          
          return out
        }

        // --- LÓGICA PARA EDIÇÃO DE CAMPANHA EXISTENTE ---
        if (modelCampaign.iuid) {
          console.log('🚀 MODO EDIÇÃO: Atualizando campanha existente...')

          // Na edição, só enviamos os campos que o backend permite atualizar.
          const updatePayload = {
            name: modelCampaign.name,
            description: modelCampaign.description,
            showHistory: modelCampaign.showHistory || false,
            active: modelCampaign.active,
            discadorCampaignID: modelCampaign.discadorCampaignID,
            filters: filter || [], // ✅ Incluir filtros legados no payload
            settings: (() => {
              const s = modelCampaign.settings || {}
              const importLimit = parseInt(s.importLimit || s.import_limit, 10)
              const exportLimit = parseInt(s.exportLimit || s.export_limit, 10)
              
              // Preservar outras configurações (ex: intuitiveFilters, selectedConvenio)
              const out = { ...s }
              
              if (Number.isFinite(importLimit) && importLimit > 0) out.importLimit = importLimit
              if (Number.isFinite(exportLimit) && exportLimit > 0) out.exportLimit = exportLimit
              
              // ✅ Incluir filtros intuitivos se fornecidos
              if (intuitivesFilters) {
                out.intuitiveFilters = intuitivesFilters
                console.log('✅ intuitiveFilters incluídos no settings (UPDATE):', Object.keys(intuitivesFilters).length, 'chaves')
              }
              
              // ✅ Incluir convênio selecionado
              if (convenio) {
                out.selectedConvenio = convenio
              }
              
              return out
            })()
          }

          await api.put(`/campaigns/${modelCampaign.iuid}`, updatePayload)
          this._vm.$snotify.success(`Campanha "${modelCampaign.name}" atualizada com sucesso!`)
          // Nota: A edição não re-importa clientes automaticamente. Isso é o comportamento esperado.

        // --- LÓGICA PARA CRIAÇÃO DE NOVA CAMPANHA ---
        } else {
          console.log('🚀 MODO CRIAÇÃO: Criando nova campanha...')

          // PASSO 1: Criar a campanha com um payload limpo.
          const createPayload = {
            name: modelCampaign.name,
            description: `Campanha para o convênio ${convenio} com aproximadamente ${totalCustomers} clientes.`,
            showHistory: modelCampaign.showHistory || false,
            active: true,
            branchId: modelCampaign.branchId || user?.branchId || null,
            discadorCampaignID: modelCampaign.discadorCampaignID,
            filters: filter || [], // ✅ Incluir filtros legados no payload
            settings: (() => {
              const s = modelCampaign.settings || {}
              const importLimit = parseInt(s.importLimit || s.import_limit, 10)
              const exportLimit = parseInt(s.exportLimit || s.export_limit, 10)
              
              // Preservar outras configurações (ex: intuitiveFilters, selectedConvenio)
              const out = { ...s }
              
              if (Number.isFinite(importLimit) && importLimit > 0) out.importLimit = importLimit
              if (Number.isFinite(exportLimit) && exportLimit > 0) out.exportLimit = exportLimit
              
              // ✅ Incluir filtros intuitivos se fornecidos
              if (intuitivesFilters) {
                out.intuitiveFilters = intuitivesFilters
                console.log('✅ intuitiveFilters incluídos no settings:', Object.keys(intuitivesFilters).length, 'chaves')
              }
              
              // ✅ Incluir convênio selecionado
              if (convenio) {
                out.selectedConvenio = convenio
              }
              
              return out
            })()
          }

          console.log('PASSO 1: Enviando dados para criar a campanha...', createPayload)
          console.log('🔍 DEBUG - branchId no payload:', createPayload.branchId)
          console.log('🔍 DEBUG - branchId do modelCampaign:', modelCampaign.branchId)
          console.log('🔍 DEBUG - branchId do user:', user?.branchId)
          createResponse = await api.post('/campaigns', createPayload)

          if (!createResponse.data?.data?.id) {
            throw new Error('Falha ao criar a campanha. O backend não retornou um ID.')
          }
          const newCampaignId = createResponse.data.data.id
          console.log('✅ PASSO 1: Campanha criada com sucesso! ID:', newCampaignId)

          // PASSO 2: Salvar os clientes na campanha recém-criada.
          if (filter && filter.length > 0 && convenio) {
            const saveCustomersPayload = {
              campaignId: newCampaignId,
              convenio: convenio,
              filters: filter
            }

            console.log('PASSO 2: Enviando dados para salvar clientes...', saveCustomersPayload)
            saveResponse = await api.post('/campaigns/save-filtered-customers', saveCustomersPayload)

            const importedCount = saveResponse.data?.data?.customersImported || 0
            this._vm.$snotify.success(`Campanha "${modelCampaign.name}" criada e ${importedCount} clientes importados!`)
          } else {
            this._vm.$snotify.success(`Campanha "${modelCampaign.name}" criada (sem clientes para importar).`)
          }
        }

        // 🔄 Emitir evento para componentes escutarem o sucesso
        if (this._vm && this._vm.$root) {
          this._vm.$root.$emit('campaign:saved')
        }

        router.push('/campaigns')
        commit('setLoading', false)
        commit('setCount', 0)

        if (config.MONITORING.DEBUG_MODE) {
          const finalResponse = saveResponse || createResponse
          if (finalResponse) { // Adicionado um 'if' para garantir que não tente logar 'null'
            console.log('🔄 submitCampaign migrated:', finalResponse.data)
          }
        }
      } catch (error) {
        commit('setLoading', false)
        console.error('submitCampaign error:', error)

        // 🔄 Emitir evento para componentes escutarem o erro
        if (this._vm && this._vm.$root) {
          this._vm.$root.$emit('campaign:error', error)
        }

        // 📊 Tratamento específico para limite diário de campanhas
        if (error.response?.status === 429 && 
            error.response?.data?.code === 'CAMPAIGN_DAILY_LIMIT_EXCEEDED') {
          const errorData = error.response.data
          const message = errorData.error || 
            `Limite diário de campanhas atingido. Você criou ${errorData.current} de ${errorData.limit} campanhas hoje. Tente novamente após ${new Date(errorData.resetAt).toLocaleString('pt-BR')}.`
          
          this._vm.$snotify.error(message, {
            timeout: 10000,
            showProgressBar: true
          })
          
          // Não redirecionar, deixar usuário na página para tentar novamente depois
          throw error
        }

        this._vm.$snotify.error('Ops! Ocorreu um erro: ' + (error.response?.data?.message || error.message))
        throw error
      }
    },

    setFilterState({ state, commit }, payload) {
      commit('setFilterState', payload)
    },

    setFilterLogic({ commit }, payload) {
      commit('setFilterLogic', payload)
    },

    addFilter({ commit }, payload) {
      commit('addFilter', payload)
    },

    removeFilter({ commit }, index) {
      commit('removeFilter', index)
    },

    clearFilters({ commit }) {
      commit('setFilterState', [])
    },

    getFilter({ commit }, filters) {
      commit('setFilterState', filters)
    },

    setCount({ commit }, count) {
      commit('setCount', count)
    },

    // 🏢 ACTIONS PARA FILTROS POR CONVÊNIO
    async loadConvenioFilters({ commit }, convenioName) {
      try {
        console.log('🔄 Carregando filtros para convênio:', convenioName)

        // Mapear nomes de convênio para compatibilidade com a API
        const convenioMap = {
          'MEX': 'EXERCITO',
          'SIAPE': 'SIAPE',
          'INSS': 'INSS',
          'FGTS': 'FGTS',
          'GOV_SC': 'GOV_SC'
        }

        const apiConvenioName = convenioMap[convenioName] || convenioName

        // Chamar nova API de convênios para obter filtros
        const response = await api.get(`/convenios/name/${apiConvenioName}/filters`)

        if (response.data.success) {
          const { fields, operators } = response.data.data

          // Mapear campos da API para o formato esperado pelo frontend
          const mappedFields = fields.map(field => {
            // Corrigir tipo de campo para campos de data
            let fieldType = field.type
            if (field.name === 'nascimento' || field.name.includes('data_') ||
                (field.label && field.label.toLowerCase().includes('data'))) {
              fieldType = 'date'
            }

            return {
              text: field.label || field.name,
              value: field.name,
              label: field.label || field.name,
              name: field.name,
              type: fieldType,
              table: field.table || 'mex_completo',
              operators: field.operators || []
            }
          })

          commit('setConvenioFilters', {
            convenio: convenioName,
            fields: mappedFields,
            operators
          })

          console.log('✅ Filtros carregados com sucesso para:', convenioName)
          return {
            success: true,
            data: {
              fields: mappedFields,
              operators,
              totalFields: mappedFields.length
            }
          }
        } else {
          throw new Error(response.data.message || 'Erro ao carregar filtros do convênio')
        }
      } catch (error) {
        console.error('❌ Erro ao carregar filtros do convênio:', error)
        commit('clearConvenioFilters')
        throw error
      }
    },

    async applyConvenioFilters({ state }, { convenio, filters, limit = 100, offset = 0 }) {
      try {
        // Mapear nomes de convênio para compatibilidade com a API
        const convenioMap = {
          'MEX': 'EXERCITO',
          'SIAPE': 'SIAPE',
          'INSS': 'INSS',
          'FGTS': 'FGTS',
          'GOV_SC': 'GOV_SC'
        }

        const apiConvenioName = convenioMap[convenio] || convenio

        // Mapear operadores do frontend para a API
        const operatorMap = {
          'eq': '=',
          'ne': '!=',
          'gt': '>',
          'gte': '>=',
          'lt': '<',
          'lte': '<=',
          'like': 'like',
          'not_like': 'not_like',
          'in': 'in',
          'not_in': 'not_in',
          'between': 'between'
        }

        const mappedFilters = filters.map(filter => ({
          field: filter.field,
          operator: operatorMap[filter.operator] || filter.operator,
          value: filter.value,
          table: filter.table
        }))

        // Chamar nova API de convênios para aplicar filtros
        const response = await api.post(`/convenios/name/${apiConvenioName}/apply-filters`, {
          filters: mappedFilters,
          logic: state.filterLogic,
          limit,
          offset
        })

        if (response.data.success) {
          console.log('✅ Filtros aplicados com sucesso. Total encontrado:', response.data.data.pagination?.total || response.data.data.length)
          return {
            success: true,
            data: {
              results: response.data.data.results || response.data.data,
              pagination: response.data.data.pagination || { total: response.data.data.length, limit, offset },
              convenio: response.data.data.convenio || apiConvenioName,
              appliedFilters: response.data.data.appliedFilters || mappedFilters
            }
          }
        } else {
          throw new Error(response.data.message || 'Erro ao aplicar filtros')
        }
      } catch (error) {
        console.error('❌ Erro ao aplicar filtros do convênio:', error)
        throw error
      }
    },

    clearConvenioFilters({ commit }) {
      commit('clearConvenioFilters')
    },

    async onCampaignCreated({ state, commit }, payload) {
      try {
        const response = await api.post('/campaigns/create-customers', {
          campaignId: payload
        })

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 onCampaignCreated migrated:', response.data)
        }

        return response.data
      } catch (error) {
        console.error('onCampaignCreated error:', error)
        throw new Error(
          error.response?.data?.message || 'Erro ao criar campanha'
        )
      }
    },

    async updateScheduleCount({ state, commit }, payload) {
      try {
        if (!state.user || state.user.profile === 'administrator') return

        const company = state.user.companyId
        const branch = state.user.branchId
        const profile = state.user.profile

        const params = {
          scheduleDate: new Date().toISOString(),
          orderBy: 'status.scheduleDate',
          ...(profile === 'attendant' && { attendantId: state.user.uid }),
          ...(profile === 'manager' && { companyId: company }),
          ...(profile === 'supervisor' && { branchId: branch })
        }

        const response = await api.get('/customers/schedule-count', { params })
        const count = response.data.count || 0

        commit('updateScheduleCount', count)

        if (config.MONITORING.DEBUG_MODE) {
          console.log('🔄 updateScheduleCount migrated:', count)
        }
      } catch (error) {
        console.error('updateScheduleCount error:', error)
        commit('updateScheduleCount', 0)
      }
    },

    // 📋 CONTRACT ACTIONS
    async getContractStatusStats({ commit, state }) {
      try {
        const response = await api.get('/contract-typing/status')
        return response.data
      } catch (error) {
        console.error('Erro ao buscar estatísticas de contratos:', error)
        throw error
      }
    },

    async getContracts({ commit, state }, params = {}) {
      try {
        const response = await api.get('/contract-typing/contracts', { params })
        return response.data
      } catch (error) {
        console.error('Erro ao buscar contratos:', error)
        throw error
      }
    },

    async getContractById({ commit, state }, id) {
      try {
        const response = await api.get(`/contract-typing/contracts/${id}`)
        return response.data
      } catch (error) {
        console.error('Erro ao buscar contrato:', error)
        throw error
      }
    },

    async updateContractStatus({ commit, state }, { id, status }) {
      try {
        const response = await api.put(`/contract-typing/contracts/${id}`, { status })
        return response.data
      } catch (error) {
        console.error('Erro ao atualizar status:', error)
        throw error
      }
    },

    async transferContract({ commit, state }, { id, newUserId }) {
      try {
        const response = await api.post(`/contract-typing/contracts/${id}/transfer`, { new_user_id: newUserId })
        return response.data
      } catch (error) {
        console.error('Erro ao transferir contrato:', error)
        throw error
      }
    },

    async getContractFiles({ commit, state }, id) {
      try {
        const response = await api.get(`/contract-typing/contracts/${id}/files`)
        return response.data
      } catch (error) {
        console.error('Erro ao carregar arquivos do contrato:', error)
        throw error
      }
    },

    async createContract({ commit, state }, formData) {
      try {
        const response = await api.post('/contract-typing/contracts', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        return response.data
      } catch (error) {
        console.error('Erro ao criar contrato:', error)
        throw error
      }
    },

    async updateContract({ commit, state }, { id, data }) {
      try {
        const response = await api.put(`/contract-typing/contracts/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        return response.data
      } catch (error) {
        console.error('Erro ao atualizar contrato:', error)
        throw error
      }
    },

    async deleteContract({ commit, state }, id) {
      try {
        const response = await api.delete(`/contract-typing/contracts/${id}`)
        return response.data
      } catch (error) {
        console.error('Erro ao deletar contrato:', error)
        throw error
      }
    },

    async getContractStatuses({ commit, state }) {
      try {
        const response = await api.get('/contract-typing/statuses')
        return response.data
      } catch (error) {
        console.error('Erro ao buscar status de contratos:', error)
        throw error
      }
    },

    async uploadContractFiles({ commit, state }, { id, files }) {
      try {
        const formData = new FormData()
        files.forEach(file => {
          formData.append('files', file)
        })

        const response = await api.post(`/contract-typing/contracts/${id}/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        return response.data
      } catch (error) {
        console.error('Erro ao fazer upload de arquivos:', error)
        throw error
      }
    }
  },

  mutations: {
    updateUsers(state, payload) {
      state.users = payload
    },

    updateCustomersInfos(state, payload) {
      state.customersInfos = payload
    },

    updateCampaigns(state, payload) {
      state.campaigns = payload
    },

    updateStatuses(state, payload) {
      state.statuses = payload
    },

    updateBoardCustomers(state, payload) {
      state.boardCustomers[payload.board] = payload.customers
    },

    setCompanyData(state, payload) {
      state.companyData = payload
    },

    agreeTerms(state, payload) {
      if (state.companyData) {
        state.companyData.terms = {
          ...payload,
          agreed: true
        }
      }
    },

    agreeContract(state, payload) {
      if (state.companyData) {
        state.companyData.contract = {
          ...payload,
          agreed: true
        }
      }
    },

    disagreeContract(state, payload) {
      if (state.companyData) {
        state.companyData.disabled = true
        state.companyData.contract = {
          plan: 'disagree',
          agreed: false
        }
      }
    },

    setLoading(state, payload) {
      state.loading = payload
    },

    setCount(state, payload) {
      state.count = payload
    },

    addFilter(state, payload) {
      // ✅ NOVO: Usar dados dinâmicos do convenioFilters ao invés de JSON estático
      const newFilter = {
        field: null, // Usuário escolherá na UI
        operator: null, // Usuário escolherá na UI
        value: '', // Usuário preencherá
        data: [], // para campos de select
        table: null, // Será definido quando field for selecionado
        type: null, // Será definido quando field for selecionado
        isCustomer: payload && payload.isCustomer || false
      }
      state.filtersState.unshift(newFilter)
    },

    removeFilter(state, index) {
      state.filtersState.splice(index, 1)
    },

    setFilterState(state, payload) {
      state.filtersState = payload
    },

    setFilterLogic(state, payload) {
      state.filterLogic = payload
    },

    // 🏢 MUTATIONS PARA FILTROS POR CONVÊNIO
    setConvenioFilters(state, payload) {
      // 🔍 LOG DETALHADO - Mutation setConvenioFilters
      console.log('🔍 DEBUG - Mutation setConvenioFilters chamada:', {
        payload,
        fieldsReceived: payload.fields,
        fieldsCount: payload.fields ? payload.fields.length : 'undefined',
        operatorsReceived: payload.operators
      })

      state.convenioFilters = {
        convenio: payload.convenio,
        fields: payload.fields,
        operators: payload.operators,
        lastUpdated: new Date().toISOString()
      }

      // 🔍 LOG DETALHADO - Estado após mutation
      console.log('🔍 DEBUG - Estado após setConvenioFilters:', {
        stateConvenioFilters: state.convenioFilters,
        stateFieldsLength: state.convenioFilters.fields ? state.convenioFilters.fields.length : 'undefined'
      })
    },

    clearConvenioFilters(state) {
      state.convenioFilters = {
        convenio: '',
        fields: [],
        operators: {},
        lastUpdated: null
      }
    },

    updateScheduleCount(state, payload) {
      state.scheduleCount = payload
    },

    // 🔐 USER MUTATIONS
    setUser(state, payload) {
      state.user = payload
    },

    setUserData(state, payload) {
      state.userData = payload
    },

    // 🔐 PASSWORD WARNING MUTATION
    setPasswordWarning(state, payload) {
      state.passwordWarning = payload
    },

    clearPasswordWarning(state) {
      state.passwordWarning = null
    },

    setSelectedConvenio(state, payload) {
      state.selectedConvenio = payload
    }
  }
})

if (config.MONITORING.DEBUG_MODE) {
  console.log(`
🎉 VUEX STORE MIGRAÇÃO CONCLUÍDA!
================================
✅ Actions migradas: 12/12
✅ Mutations: Mantidas (100% compatíveis)
✅ Getters: Mantidos (100% compatíveis)
✅ State: Mantido (100% compatível)

🔄 Actions migradas:
• loadUsers
• loadCustomersInfos  
• loadCampaigns
• loadStatuses
• loadBoardCustomers
• updateCustomer
• loadCompanyData
• findUsersCount
• agreeTerms
• agreeContract
• disagreeContract
• submitCampaign
• onCampaignCreated
• updateScheduleCount

🔗 API URL: ${config.API.API_URL}
`)
}
